import { PlayerEvent } from '@foundation-player/runtime';
import { PlayerInterface } from '@foundation-player/types';
import { parse as vttParser } from '@plussub/srt-vtt-parser';
import { CueEvent } from '../event-emitter/unfiltered';

export interface VttEntry {
  id: string;
  from: number;
  to: number;
  text: string;
}
export class VttCueEventEmitter {
  private readonly vttEntries: VttEntry[];
  private readonly player: PlayerInterface;
  private lastVttEntry?: VttEntry;

  constructor(
    public vttId: string,
    vtt: string,
    player: PlayerInterface,
  ) {
    this.vttEntries = vttParser(vtt).entries.map((entry, idx) => {
      // if the vtt does not have unique IDs, use the position of the entry instead
      return { ...entry, id: entry.id || `cue-${idx.toString()}` };
    });
    this.player = player;

    player.addEventListener(PlayerEvent.TimeChanged, this.timeChangedFired);
    this.timeChangedFired();
  }

  stopEmitting() {
    this.emitCueExitForLastVtt();
    this.player.removeEventListener(PlayerEvent.TimeChanged, this.timeChangedFired);
  }

  timeChangedFired = () => {
    const currentTime = this.player.getCurrentTime() * 1000;

    const vttEntry = this.vttEntries.find((entry) => entry.from <= currentTime && entry.to > currentTime);

    if (vttEntry && (this.lastVttEntry == undefined || vttEntry.id != this.lastVttEntry.id)) {
      this.emitCueExitForLastVtt();
      this.lastVttEntry = vttEntry;
      this.player.dispatchEvent(
        new CueEvent(PlayerEvent.CueEnter, {
          start: vttEntry.from / 1000,
          end: vttEntry.to / 1000,
          text: vttEntry.text,
          cueId: vttEntry.id,
        }),
      );
    } else if (vttEntry == undefined && this.lastVttEntry != undefined) {
      this.emitCueExitForLastVtt();
    }
  };

  emitCueExitForLastVtt() {
    if (this.lastVttEntry) {
      this.player.dispatchEvent(
        new CueEvent(PlayerEvent.CueExit, {
          start: this.lastVttEntry.from / 1000,
          end: this.lastVttEntry.to / 1000,
          text: this.lastVttEntry.text,
          cueId: this.lastVttEntry.id,
        }),
      );
      this.lastVttEntry = undefined;
    }
  }
}
